import React from "react";
import { withTranslation } from "react-i18next";
import { RepseStatusByCompanyView } from "../../views";
import { LocalStorageService, RepseService } from "../../../services";

let dummy_companies = [
  {
    id: 1,
    name: "La Empresota",
    compliance: [
      {
        year: "2023",
        month: 3,
        status: "success",
      },
      {
        year: "2023",
        month: 4,
        status: "failed",
      },
    ],
    contractors: [
      {
        id: 127,
        emailContractor: "mazdaautos@mailinator.com",
        emailCreator: "mcarrizales@govo.legal",
        contractorPersonTypeId: 1,
        name: "Mazda",
        clientId: 8,
        limitDate: "2023-03-13T21:18:58.909Z",
        rfc: "GOCM860812QA2",
        curp: null,
        contractorStreet: "Reforma #300",
        contractorTownship: "Cuahutémoc",
        contractorState: "CDMX",
        contractorZipCode: "45637",
        contractorCountry: "México",
        active: true,
        notes: "Notes",
        clientContractCurrentId: "529",
        isRepse: true,
        repseSince: "2023-03-14T23:52:24.381Z",
        createdDate: "2023-03-13T21:20:24.402Z",
        updatedDate: "2023-03-14T22:19:09.724Z",
        updatedByUser: "mcarrizales@govo.legal",
        documents: [
          {
            id: 93,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Opinión de cumplimiento IMSS",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:16:12.793Z",
            updatedDate: "2023-04-17T23:16:36.818Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 8,
                contractorId: 127,
                documentId: 93,
                filePath: "contractor/127/repse/2023/3/93.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:19:03.483Z",
                updatedDate: "2023-04-17T20:19:03.483Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 93,
                  name: "Opinión de cumplimiento IMSS",
                },
              },
              {
                id: 18,
                contractorId: 127,
                documentId: 93,
                filePath: "contractor/127/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:24:03.833Z",
                updatedDate: "2023-04-17T20:24:03.833Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 93,
                  name: "Opinión de cumplimiento IMSS",
                },
              },
            ],
          },
          {
            id: 92,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Opinión de cumplimiento SAT",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:15:57.585Z",
            updatedDate: "2023-04-17T23:16:47.970Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 7,
                contractorId: 127,
                documentId: 92,
                filePath: "contractor/127/repse/2023/3/92.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:19:03.409Z",
                updatedDate: "2023-04-17T20:19:03.409Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 92,
                  name: "Opinión de cumplimiento SAT",
                },
              },
              {
                id: 17,
                contractorId: 127,
                documentId: 92,
                filePath: "contractor/127/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "due",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:24:03.761Z",
                updatedDate: "2023-04-17T20:24:03.761Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 92,
                  name: "Opinión de cumplimiento SAT",
                },
              },
            ],
          },
          {
            id: 94,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Acuse de recibo declaración provisional ISR",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:17:39.079Z",
            updatedDate: "2023-04-17T23:17:39.079Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 9,
                contractorId: 127,
                documentId: 94,
                filePath: "contractor/127/repse/2023/3/94.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:19:03.557Z",
                updatedDate: "2023-04-17T20:19:03.557Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 94,
                  name: "Acuse de recibo declaración provisional ISR",
                },
              },
              {
                id: 19,
                contractorId: 127,
                documentId: 94,
                filePath: "contractor/127/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "loaded",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:24:03.906Z",
                updatedDate: "2023-04-17T20:24:03.906Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 94,
                  name: "Acuse de recibo declaración provisional ISR",
                },
              },
            ],
          },
          {
            id: 95,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Recibo bancario de pago ISR",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:17:57.541Z",
            updatedDate: "2023-04-17T23:17:57.541Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 10,
                contractorId: 127,
                documentId: 95,
                filePath: "contractor/127/repse/2023/3/95.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:19:03.631Z",
                updatedDate: "2023-04-17T20:19:03.631Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 95,
                  name: "Recibo bancario de pago ISR",
                },
              },
              {
                id: 20,
                contractorId: 127,
                documentId: 95,
                filePath: "contractor/127/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "loaded",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:24:03.980Z",
                updatedDate: "2023-04-17T20:24:03.980Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 95,
                  name: "Recibo bancario de pago ISR",
                },
              },
            ],
          },
          {
            id: 96,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Cuotas obrero patronales SUA",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:18:16.384Z",
            updatedDate: "2023-04-17T23:18:16.384Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 11,
                contractorId: 127,
                documentId: 96,
                filePath: "contractor/127/repse/2023/3/96.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:19:03.705Z",
                updatedDate: "2023-04-17T20:19:03.705Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 96,
                  name: "Cuotas obrero patronales SUA",
                },
              },
              {
                id: 21,
                contractorId: 127,
                documentId: 96,
                filePath: "contractor/127/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:24:04.053Z",
                updatedDate: "2023-04-17T20:24:04.053Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 96,
                  name: "Cuotas obrero patronales SUA",
                },
              },
            ],
          },
        ],
        compliance: [
          {
            year: "2023",
            month: 3,
            status: "success",
          },
          {
            year: "2023",
            month: 4,
            status: "failed",
          },
        ],
      },
      {
        id: 136,
        emailContractor: "kiatest@mailinator.com",
        emailCreator: "mcarrizales@govo.legal",
        contractorPersonTypeId: 2,
        name: "KIA",
        clientId: 8,
        limitDate: "2023-03-14T23:28:23.479Z",
        rfc: "R2DFAQSDFSQADFQ",
        curp: null,
        contractorStreet: "Mateo Acuña",
        contractorTownship: "Victoria",
        contractorState: "Tamaulipas",
        contractorZipCode: "87076",
        contractorCountry: "México",
        active: true,
        notes: "Notes",
        clientContractCurrentId: "554",
        isRepse: true,
        repseSince: "2023-03-10T23:52:24.381Z",
        createdDate: "2023-03-14T23:29:07.007Z",
        updatedDate: "2023-03-14T23:52:24.381Z",
        updatedByUser: "kiatest@mailinator.com",
        documents: [
          {
            id: 93,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Opinión de cumplimiento IMSS",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:16:12.793Z",
            updatedDate: "2023-04-17T23:16:36.818Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 3,
                contractorId: 136,
                documentId: 93,
                filePath: "contractor/136/repse/2023/3/93.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.738Z",
                updatedDate: "2023-04-17T20:17:23.738Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 93,
                  name: "Opinión de cumplimiento IMSS",
                },
              },
              {
                id: 13,
                contractorId: 136,
                documentId: 93,
                filePath: "contractor/136/repse/2023/4/93.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.553Z",
                updatedDate: "2023-04-17T20:21:08.553Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 93,
                  name: "Opinión de cumplimiento IMSS",
                },
              },
            ],
          },
          {
            id: 92,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Opinión de cumplimiento SAT",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:15:57.585Z",
            updatedDate: "2023-04-17T23:16:47.970Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 2,
                contractorId: 136,
                documentId: 92,
                filePath: "contractor/136/repse/2023/3/92.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.665Z",
                updatedDate: "2023-04-17T20:17:23.665Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 92,
                  name: "Opinión de cumplimiento SAT",
                },
              },
              {
                id: 12,
                contractorId: 136,
                documentId: 92,
                filePath: "contractor/136/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.479Z",
                updatedDate: "2023-04-17T20:21:08.479Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 92,
                  name: "Opinión de cumplimiento SAT",
                },
              },
            ],
          },
          {
            id: 94,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Acuse de recibo declaración provisional ISR",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:17:39.079Z",
            updatedDate: "2023-04-17T23:17:39.079Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 4,
                contractorId: 136,
                documentId: 94,
                filePath: "contractor/136/repse/2023/3/94.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.811Z",
                updatedDate: "2023-04-17T20:17:23.811Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 94,
                  name: "Acuse de recibo declaración provisional ISR",
                },
              },
              {
                id: 14,
                contractorId: 136,
                documentId: 94,
                filePath: "contractor/136/repse/2023/4/94.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.626Z",
                updatedDate: "2023-04-17T20:21:08.626Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 94,
                  name: "Acuse de recibo declaración provisional ISR",
                },
              },
            ],
          },
          {
            id: 95,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Recibo bancario de pago ISR",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:17:57.541Z",
            updatedDate: "2023-04-17T23:17:57.541Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 5,
                contractorId: 136,
                documentId: 95,
                filePath: "contractor/136/repse/2023/3/95.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.885Z",
                updatedDate: "2023-04-17T20:17:23.885Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 95,
                  name: "Recibo bancario de pago ISR",
                },
              },
              {
                id: 15,
                contractorId: 136,
                documentId: 95,
                filePath: "contractor/136/repse/2023/4/95.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.700Z",
                updatedDate: "2023-04-17T20:21:08.700Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 95,
                  name: "Recibo bancario de pago ISR",
                },
              },
            ],
          },
          {
            id: 96,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Cuotas obrero patronales SUA",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:18:16.384Z",
            updatedDate: "2023-04-17T23:18:16.384Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 6,
                contractorId: 136,
                documentId: 96,
                filePath: "contractor/136/repse/2023/3/96.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.959Z",
                updatedDate: "2023-04-17T20:17:23.959Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 96,
                  name: "Cuotas obrero patronales SUA",
                },
              },
              {
                id: 16,
                contractorId: 136,
                documentId: 96,
                filePath: "contractor/136/repse/2023/4/96.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.773Z",
                updatedDate: "2023-04-17T20:21:08.773Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 96,
                  name: "Cuotas obrero patronales SUA",
                },
              },
            ],
          },
        ],
        compliance: [
          {
            year: "2023",
            month: 3,
            status: "success",
          },
          {
            year: "2023",
            month: 4,
            status: "success",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Empresa Super X",
    compliance: [
      {
        year: "2023",
        month: 3,
        status: "success",
      },
      {
        year: "2023",
        month: 4,
        status: "success",
      },
    ],
    contractors: [
      {
        id: 136,
        emailContractor: "kiatest@mailinator.com",
        emailCreator: "mcarrizales@govo.legal",
        contractorPersonTypeId: 2,
        name: "KIA",
        clientId: 8,
        limitDate: "2023-03-14T23:28:23.479Z",
        rfc: "R2DFAQSDFSQADFQ",
        curp: null,
        contractorStreet: "Mateo Acuña",
        contractorTownship: "Victoria",
        contractorState: "Tamaulipas",
        contractorZipCode: "87076",
        contractorCountry: "México",
        active: true,
        notes: "Notes",
        clientContractCurrentId: "554",
        isRepse: true,
        repseSince: "2023-03-10T23:52:24.381Z",
        createdDate: "2023-03-14T23:29:07.007Z",
        updatedDate: "2023-03-14T23:52:24.381Z",
        updatedByUser: "kiatest@mailinator.com",
        documents: [
          {
            id: 93,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Opinión de cumplimiento IMSS",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:16:12.793Z",
            updatedDate: "2023-04-17T23:16:36.818Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 3,
                contractorId: 136,
                documentId: 93,
                filePath: "contractor/136/repse/2023/3/93.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.738Z",
                updatedDate: "2023-04-17T20:17:23.738Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 93,
                  name: "Opinión de cumplimiento IMSS",
                },
              },
              {
                id: 13,
                contractorId: 136,
                documentId: 93,
                filePath: "contractor/136/repse/2023/4/93.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.553Z",
                updatedDate: "2023-04-17T20:21:08.553Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 93,
                  name: "Opinión de cumplimiento IMSS",
                },
              },
            ],
          },
          {
            id: 92,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Opinión de cumplimiento SAT",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:15:57.585Z",
            updatedDate: "2023-04-17T23:16:47.970Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 2,
                contractorId: 136,
                documentId: 92,
                filePath: "contractor/136/repse/2023/3/92.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.665Z",
                updatedDate: "2023-04-17T20:17:23.665Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 92,
                  name: "Opinión de cumplimiento SAT",
                },
              },
              {
                id: 12,
                contractorId: 136,
                documentId: 92,
                filePath: "contractor/136/repse/2023/4/92.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.479Z",
                updatedDate: "2023-04-17T20:21:08.479Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 92,
                  name: "Opinión de cumplimiento SAT",
                },
              },
            ],
          },
          {
            id: 94,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Acuse de recibo declaración provisional ISR",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:17:39.079Z",
            updatedDate: "2023-04-17T23:17:39.079Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 4,
                contractorId: 136,
                documentId: 94,
                filePath: "contractor/136/repse/2023/3/94.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.811Z",
                updatedDate: "2023-04-17T20:17:23.811Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 94,
                  name: "Acuse de recibo declaración provisional ISR",
                },
              },
              {
                id: 14,
                contractorId: 136,
                documentId: 94,
                filePath: "contractor/136/repse/2023/4/94.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.626Z",
                updatedDate: "2023-04-17T20:21:08.626Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 94,
                  name: "Acuse de recibo declaración provisional ISR",
                },
              },
            ],
          },
          {
            id: 95,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Recibo bancario de pago ISR",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:17:57.541Z",
            updatedDate: "2023-04-17T23:17:57.541Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 5,
                contractorId: 136,
                documentId: 95,
                filePath: "contractor/136/repse/2023/3/95.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.885Z",
                updatedDate: "2023-04-17T20:17:23.885Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 95,
                  name: "Recibo bancario de pago ISR",
                },
              },
              {
                id: 15,
                contractorId: 136,
                documentId: 95,
                filePath: "contractor/136/repse/2023/4/95.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.700Z",
                updatedDate: "2023-04-17T20:21:08.700Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 95,
                  name: "Recibo bancario de pago ISR",
                },
              },
            ],
          },
          {
            id: 96,
            clientId: 8,
            documentPersonTypeId: 2,
            name: "Cuotas obrero patronales SUA",
            description: "REPSE",
            logo: "none",
            defaultDocument: false,
            order: null,
            clientDocumentActionId: 0,
            active: true,
            key: null,
            createdDate: "2023-04-17T23:18:16.384Z",
            updatedDate: "2023-04-17T23:18:16.384Z",
            updatedByUser: "mcarrizales@govo.legal",
            clientDocumentTypeRequestId: 0,
            compliance: [
              {
                id: 6,
                contractorId: 136,
                documentId: 96,
                filePath: "contractor/136/repse/2023/3/96.pdf",
                year: 2023,
                month: 3,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "opena@govo.legal",
                createdDate: "2023-04-17T20:17:23.959Z",
                updatedDate: "2023-04-17T20:17:23.959Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 96,
                  name: "Cuotas obrero patronales SUA",
                },
              },
              {
                id: 16,
                contractorId: 136,
                documentId: 96,
                filePath: "contractor/136/repse/2023/4/96.pdf",
                year: 2023,
                month: 4,
                statusDocument: "validated",
                createdBy: "bsalas@govo.legal",
                authorizedBy: "bsalas@govo.legal",
                createdDate: "2023-04-17T20:21:08.773Z",
                updatedDate: "2023-04-17T20:21:08.773Z",
                updatedByUser: "opena@govo.legal",
                clientDocument: {
                  id: 96,
                  name: "Cuotas obrero patronales SUA",
                },
              },
            ],
          },
        ],
        compliance: [
          {
            year: "2023",
            month: 3,
            status: "success",
          },
          {
            year: "2023",
            month: 4,
            status: "success",
          },
        ],
      },
    ],
  },
];

const years = [
  {
    year: "2022",
    yearValue: "2022",
  },
  {
    year: "2023",
    yearValue: "2023",
  },
  {
    year: "2024",
    yearValue: "2024",
  },
  {
    year: "2025",
    yearValue: "2025",
  },
];

class RepseStatusByCompanyAction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      companies: [],
      contractors: [],
      documents: [],
      yearFilterOptions: years,
      selectedYear: 2023,
      monthNumber: 0,
      month: "",
      selectedMonth: false,
      selectedCompany: null,
      selectedContractor: null,
      error: "",
      token: '',
      email: ''
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  repseService = new RepseService(this.url);

  onYearFilterChange = async (year) => {
    await this.getCompanyData(year);
    this.setState({
      selectedCompany: null,
      selectedContractor: null,
      contractors: [],
      documents: [],
      error: "",
    });
  };

  // COMPANIES
  getCompanyData = async (year) => {
    // this.setState({
    //     companies: dummy_companies,
    //     selectedYear: year
    // });
    this.setState({
      loading: true,
      selectedYear: year,
    });

    try {
      let data = await this.repseService.getAllRepseDocuments(this.token, year);
      let companies = data.data;

      if (!companies) {
        throw new Error("No hay datos");
      }

      this.setState({
        companies,
      });
    } catch (e) {
      this.setState({
        error: e.message,
        companies: [],
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  getColorByCompanyStatus = (status) => {
    switch (status) {
      case "success":
        return "green";
      case "failed":
        return "red";
      default:
        return "";
    }
  };

  onCompanySelected = (company) => {
    // let contractors = this.filterContractorsByYear(this.state.selectedCompanyYear, company.contractors);
    this.setState({
      selectedCompany: company,
      contractors: company.contractors,
    });
  };

  // CONTRACTORS
  getColorByContractorStatus = (status) => {
    switch (status) {
      case "success":
        return "green";
      case "failed":
        return "red";
      default:
        return "";
    }
  };

  onContractorSelected = (contractor) => {
    // let documents = this.filterDocumentsByYear(this.state.selectedContractorYear, contractor.documents);

    this.setState({
      selectedContractor: contractor,
      documents: contractor.documents,
    });
  };

  onBackContractorScreen = () => {
    this.setState({
      selectedCompany: null,
      contractors: [],
    });
  };

  // DOCUMENTS
  getColorByDocumentStatus = (status) => {
    switch (status) {
      case "validated":
        return "green";
      case "loaded":
        return "yellow";
      case "due":
        return "red";
      default:
        return "";
    }
  };

  getDocumentUrl = async (path) => {
    let response = await this.repseService.getDocumentUrl(this.token, path);
    return response;
  }

  onBackDocumentScreen = () => {
    this.setState({
      selectedContractor: null,
      documents: [],
    });
  };

  onMonthSelected = (value, number, month) => {
    this.setState({
      monthSelected: value,
      monthNumber: number,
      month: month
    });
  };

  async componentDidMount() {
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");
    let email = user.userMetaData.userA3Cloud.email
    this.setState({
      email,
      token : this.token
    })
    await this.getCompanyData(2023);
  }

  render() {
    return (
      <RepseStatusByCompanyView
        {...this.state}
        onYearFilterChange={this.onYearFilterChange}

        getColorByCompanyStatus={this.getColorByCompanyStatus}
        onCompanySelected={this.onCompanySelected}

        getColorByContractorStatus={this.getColorByContractorStatus}
        onContractorSelected={this.onContractorSelected}
        onBackContractorScreen={this.onBackContractorScreen}

        getColorByDocumentStatus={this.getColorByDocumentStatus}
        onBackDocumentScreen={this.onBackDocumentScreen}
        getDocumentUrl={this.getDocumentUrl}
        onMonthSelected={this.onMonthSelected}
      />
    )
  }
}

export default withTranslation()(RepseStatusByCompanyAction);
